<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div
        class="col-12 col-lg-8"
        v-if="sortedHostQuizzes && sortedHostQuizzes.length == 0"
      >
        <HostNoQuizInfo />
      </div>
      <div
        class="col-12 col-lg-8"
        v-bind:class="{ 'd-none': sortedHostQuizzes !== null }"
        v-b-visible="loadingVisible"
      >
        Loading ...
      </div>
      <div
        class="col-12 col-lg-8 mb-3"
        v-for="quiz in sortedHostQuizzes"
        v-bind:key="quiz.id"
      >
        <HostQuizItem
          v-bind:quiz="quiz"
          @host-changed-time="onQuizTimeChangedByHost"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HostQuizItem from "@/components/HostQuizItem";
import HostNoQuizInfo from "@/components/host/HostNoQuizInfo";
import { mapGetters } from "vuex";

export default {
  name: "HostDashboardHome",
  components: {
    HostQuizItem,
    HostNoQuizInfo
  },
  data() {
    return {
      // list of hosted quizzes
      hostedQuizzes: {},
      // quiz selected when intending to join
      selectedQuiz: {},
      // set false when quizzes have loaded once
      loading: true,
      scrollOnLoad: -1
    };
  },
  computed: {
    ...mapGetters({
      sortedHostQuizzes: "quizStore/sortedHostQuizzes"
    })
  },
  created() {
    this.scrollOnLoad = localStorage.getItem("FreshQuiz");
    localStorage.removeItem("FreshQuiz");

    var options = { requiredRole: this.$tqConstants.USER_ROLE_HOST };
    this.$topquiz.checkSession(
      options,
      this.onSessionChecked,
      this.onUserRoleNotSufficient
    );

    this.$store.dispatch("quizStore/loadHostedQuizzes", this);
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  },
  methods: {
    scrollToAsync(quizID, delay = 100) {
      setTimeout(() => {
        if (!isNaN(quizID) && quizID > 0) {
          document.getElementById("hostItem_" + quizID).scrollIntoView({
            behavior: "auto",
            block: "center",
            inline: "center"
          });
        }
      }, delay);
    },
    onSessionChecked() {
      this.$topquiz.sendCommand(
        "getHostedQuizzes",
        this.$topquiz.SessionKey,
        this.$tqConstants["QUIZ_STATUS_ENDED"]
      );
    },
    onUserRoleNotSufficient() {
      this.$router.replace("/dashboard");
    },
    onQuizTimeChangedByHost(quizID) {
      this.scrollToAsync(quizID, 500); // give time for list update
    },
    loadingVisible(visible) {
      if (!visible) {
        this.scrollToAsync(this.scrollOnLoad);
      }
    }
  }
};
</script>
